import { TListingCompilationSettings } from '../../../types/blackFriday';
import { IListingCompilation } from '../../../types/promosPage';
import { IRegionMeta } from '../../../types/regionMeta';
import { getBlackFridayRegionedUrl } from '../../../utils/urls';

export function getListingCompilationUrl(
  item: IListingCompilation,
  listingCompilationSettings: TListingCompilationSettings,
  currentRegion: IRegionMeta,
) {
  const url = listingCompilationSettings[item.type]?.url;

  return url ? getBlackFridayRegionedUrl(url, currentRegion) : '/';
}
